import axios from 'axios'

export const store = {
  state: () => ({
    isMobile: /(iPhone|Android|Mobile)/gi.test(navigator.userAgent),
    apiDomain: process.env.VUE_APP_API_DOMAIN,
    content: {},
    scene: 'night',
    sceneName: 'Armed and Adorable',
    animating: false,
    animatingTimeout: null,
    modal: null,
  }),

  mutations: {
    setContentHome(state, value) {
      state.content = value
    },
    // setContentNight (state, value) {
    //   state.content.night = value
    //   if (state.scene === 'night' && state.content.night.Title) {
    //     state.sceneName = state.content.night.Title
    //   }
    // },
    setContentVillage(state, value) {
      state.content.village = value
    },
    setContentFriends(state, value) {
      state.content.friends = value
    },
    setContentWorld(state, value) {
      state.content.world = value
    },
    setContentUnderground(state, value) {
      state.content.underground = value
    },
    setContentFooter(state, value) {
      state.content.footer = value
    },
    setScene(state, value) {
      if (!state.animating && !state.modal) {
        state.animating = true
        state.scene = value
        switch (value) {
          case 'night':
            state.sceneName = 'Armed and Adorable'
            break
          case 'village':
            state.sceneName = 'Welcome to MapleStory'
            break
          case 'friends':
            state.sceneName = 'Find Friends'
            break
          case 'world':
            state.sceneName = 'Maple World'
            break
          case 'underground':
            state.sceneName = 'Choose Your Hero'
            break
          case 'footer':
            state.sceneName = 'Tutorials'
            break
          default:
            state.sceneName = value.charAt(0).toUpperCase() + value.slice(1)
            break
        }
        state.animatingTimeout = setTimeout(() => {
          state.animating = false
        }, 2000)
      }
    },
    // setAnimating (state, value) {
    //   state.animating = value
    // },
    setModal(state, value) {
      state.modal = value
    },
  },

  actions: {
    async setContentHome({ commit, state }) {
      if (!state.content.Logo) {
        const { data } = await axios.get(`${process.env.VUE_APP_MS_CMS_PATH}/landing`)

        commit('setContentHome', data)

        // commit('setContentVillage', data.Village)
        // commit('setContentFriends', data.Friend)
        // commit('setContentWorld', data.World)
        // commit('setContentUnderground', data.Underground)
        // commit('setContentFooter', data.Footer)
      }
    },
    // setContentVillage ({ commit, getters }) {
    //   // if (!getters.getContentVillage) {
    //   //   axios.all([
    //   //     axios.get(`${process.env.VUE_APP_API_PATH}/village`)
    //   //   ])
    //   //   .then(axios.spread((village) => {
    //   //     commit('setContentVillage', village.data)
    //   //   }))
    //   // }
    // },
    // setContentRest ({ commit, getters }) {
    //   // if (!getters.getContentWorld) {
    //   //   axios.all([
    //   //     axios.get(`${process.env.VUE_APP_API_PATH}/friends`),
    //   //     axios.get(`${process.env.VUE_APP_API_PATH}/world`),
    //   //     axios.get(`${process.env.VUE_APP_API_PATH}/underground`),
    //   //     axios.get(`${process.env.VUE_APP_API_PATH}/footer`)
    //   //   ])
    //   //   .then(axios.spread((friends, world, underground, footer) => {
    //   //     commit('setContentFriends', friends.data)
    //   //     commit('setContentWorld', world.data)
    //   //     commit('setContentUnderground', underground.data)
    //   //     commit('setContentFooter', footer.data)
    //   //   }))
    //   // }
    // },
    setScene({ commit }, value) {
      commit('setScene', value)
    },
    // setAnimating ({ commit }, value) {
    //   commit('setAnimating', value);
    // },
    setModal({ commit }, value) {
      commit('setModal', value)
    },
  },

  getters: {
    // getApiDomain: state => {
    //   return state.apiDomain
    // },
    // getContentNight: state => {
    //   return state.content.night ? state.content.night : null
    // },
    getIsMobile: (state) => {
      return state.isMobile
    },
    getContentHome: (state) => {
      return state.content
    },
    getContentVillage: (state) => {
      return state.content.Village
    },
    getContentWorld: (state) => {
      return state.content.World
    },
    getContentFriends: (state) => {
      return state.content.Friend
    },
    getContentUnderground: (state) => {
      return state.content.Underground
    },
    getContentFooter: (state) => {
      return state.content.Footer
    },
    getScene: (state) => {
      return state.scene
    },
    getSceneName: (state) => {
      return state.sceneName
    },
    // getAnimating: state => {
    //   return state.animating
    // },
    getModal: (state) => {
      return state.modal
    },
  },
}
